

































































































































































































api = require('../../api.coffee').api()
helpers = require('../../helpers.coffee')

view_model = {
  props:
    save_button_text:
      default: () -> this.$t('flows.actions.new')

    cancel_path:
      default: '/fluxos-de-cadencia'

    flow:
      default: -> new Flow

    type_of_action:
      default: () -> this.$t('flows.actions.newFromLib')

  components:
    actionPicker: require '../flow_actions/picker'
    contactsForm: require './contacts_form'
    flows: require '../shared/autocomplete/flows.vue'

  data: ->
    has_emails_per_day: false
    old_activation_limit: null
    flow_categories: []
    save_flow_after_validations: false
    delay_before_finishing_contact_amount: 1
    delay_before_finishing_contact_unit: 'days'
    disabledStageLost: false
    lostReasonId: ''

    lost_reason: 'reason 1'

    sent_to_flow: false
    selected_user: Session.current_user.id
    weekdays:
      [ 
        this.capitalizeFirstLetter(this.$t('general.label.sun')),
        this.capitalizeFirstLetter(this.$t('general.label.mon')),
        this.capitalizeFirstLetter(this.$t('general.label.tue')),
        this.capitalizeFirstLetter(this.$t('general.label.wed')),
        this.capitalizeFirstLetter(this.$t('general.label.thu')),
        this.capitalizeFirstLetter(this.$t('general.label.fri')),
        this.capitalizeFirstLetter(this.$t('general.label.sat'))
      ]

    pristine: true
    apiErrorMessages: []

    action_errors: {}

  computed:
    all_errors: ->
      errors = {}
      for error in @errors.errors
        errors[error.field] = error.msg
      Object.assign({}, errors, @action_errors)

    flow_type_label: ->
      if @flow.semi_automatic then this.$t('flows.label.semiAutomatedFlow') else this.$t('flows.label.automatedFlow')

    modal_title: ->
      if !@has_emails_per_day then @$t('flows.title.noLimitWarning') else @$t('flows.title.limitChangeWarning')

    modal_message: ->
      if !@has_emails_per_day then @$t('flows.text.noLimitWarning') else @$t('flows.text.limitChangeWarning')

    modal_confirm_text: ->
      if !@has_emails_per_day then @$t('general.label.yes') else @$t('general.actions.ok')

    has_changed_activation_limit: ->
      @is_editing && (@old_activation_limit != parseInt(@flow.emails_per_day))

    is_editing: ->
      @flow?.id

    isReevAccount: ->
      [1, 2, 1169, 1709, 1901, 2115, 2120, 2228, 2602].includes(Session.current_company.id)

  methods:
    toggleTaskTimer: ->
      if @isReevAccount
        @flow.toggleTaskTimer()

    capitalizeFirstLetter: (string) ->
      helpers.masks.capitalizeFirstLetter(string)

    checkStage: ->
      @flow.set_lost_on_finish = !@flow.set_lost_on_finish

    lostReasonOptions: (flowId) ->
      result = []
      noConnection = this.$t('flows.label.noConnection')
      this.$store.dispatch('fetchLostReasons') if this.$store.getters.lostReasonsCount == 0
      for lost_reason in this.$store.getters.lostReasonsList
        if lost_reason.title == noConnection
          @flow.lost_reason_id = lost_reason.id unless @flow.id || @flow.lost_reason_id

          result.unshift { value: lost_reason.id, text: lost_reason.title }
        else
          result.push { value: lost_reason.id, text: lost_reason.title }

      @flow.lost_reason_id = result[0]?.value unless @flow.lost_reason_id

      if result.length != 0 && this.lostReasonId != @flow.lost_reason_id
        indexLostReason = @flow.lost_reason_id
        stageLost = result.find (item) ->
          return item.value == indexLostReason

        if !stageLost
          this.disabledStageLost = false
        else if stageLost.text != noConnection
          this.disabledStageLost = true
          this.lostReasonId = stageLost.value
        else
          this.disabledStageLost = false
          this.lostReasonId = stageLost.value

        @flow.set_lost_on_finish = true

      result 

    loadFlowCategories: () ->
      api.get "/companies/#{Session.current_company.id}/flow_categories", {}, { success: @flowCategoriesSuccess, failure: @flowCategoriesFailure }

    flowCategoriesSuccess: (data) ->
      @flow_categories = data.body.flow_categories.map (flow_category) -> { text: flow_category.name, value: flow_category.id }
      if !@flow.category_id
        @flow.category_id = @flow_categories[0]?.value

    flowCategoriesFailure: (error) ->
      console.error(error)

    validTriggers: ->
      for trigger in @flow.triggers
        if @flow.triggers.filter( (t) -> t.trigger_type == trigger.trigger_type && t.trigger_value == trigger.trigger_value && t.action_type == trigger.action_type && !trigger._destroy).length > 1
          alertify.error(this.$t('flows.label.errors.markedTriggers')); 
          return false
        if ['stage'].indexOf(trigger.trigger_type) > -1 && !trigger.trigger_value && !t._destroy
          alertify.error(this.$t('flows.label.errors.needAction'));
          return false
        if ['insert_into_a_group', 'send_to_new_flow', 'fill_property', 'change_stage', 'change_responsible'].indexOf(trigger.action_type) > -1 && !trigger.action_value && !trigger._destroy
          alertify.error(this.$t('flows.label.errors.needAction'));
          return false
        if ['fill_property'].indexOf(trigger.action_type) > -1 && !trigger.action_target && !t._destroy
          alertify.error(this.$t('flows.label.errors.needProperty'));
          return false
        if ['hours', 'days', 'weeks', 'months'].indexOf(trigger.timming_type) > -1 && !trigger.timming_value && ['send_to_new_flow', 'change_stage'].indexOf(trigger.action_type) > -1 && !trigger._destroy
          alertify.error(this.$t('flows.label.errors.needSetTime'));
          return false
        if trigger.trigger_type == 'lost' && !trigger.trigger_value
          if @flow.triggers.filter( (t) -> t.trigger_type == trigger.trigger_type && !trigger._destroy).length > 1
            alertify.error(this.$t('flows.label.errors.triggerConflicts'));
            return false
        if (trigger.action_type == 'change_responsible' && !trigger._destroy && @flow.triggers.some((t) => t.trigger_type == trigger.trigger_type && !t._destroy && ['send_to_new_flow', 'insert_into_a_group'].includes(t.action_type)))
          alertify.error(this.$t('flows.label.errors.responsibleAndFlowConflictError'));
          return false

      true

    switchSendToFlow: ->
      @sent_to_flow = !@sent_to_flow
      if !@sent_to_flow
        @selected_flow = null
        payload = 
          type: 'flow_data'
          value: null
          switch: false
        @$store.dispatch 'setOrganizationOptions', payload
      @$emit 'flowSwitch', @sent_to_flow
    
    selectFlow: (flow) ->
      @selected_flow = flow
      payload = 
        type: 'flow_data'
        value: Number(@selected_flow.id)
        switch: @sent_to_flow
      @$store.dispatch 'setOrganizationOptions', payload
      @$emit 'fillFlow', Number(@selected_flow.id)
      return

    toggleType: ->
      @flow.toggleType() if @flow.canEditActions()

    onCategoryChange: (category_id) ->
      if category_id != 3
        @flow.with_task_timer = false

    validateAll: ->
      Vue.delete @action_errors, 'required'
      Vue.delete @action_errors, 'send_at'
      Vue.delete @action_errors, 'delay_after_previous_step_amount'
      Vue.delete @action_errors, 'template'
      @setDirty()
      @$validator.validateAll()

    submit: ->
      @save_flow_after_validations = true
      EventsBus.$emit 'validate-all'

    validateAndSaveFlow: ->
      @save_flow_after_validations = false
      unless @isValid()
        jQuery('html, body').animate({scrollTop: 0}, 500);
        return
      return unless @validTriggers()

      if !@has_emails_per_day || @has_changed_activation_limit
        EventsBus.$emit 'confirm-modal-show', id: 'confirm-save'
        return

      @saveFlow()

    saveFlow: ->
      @ensureActionStepOrder()
      @ensureActionSendAt()
      @ensureEmailsPerDay()
      @ensureEmptyTaskParameters()

      @flow.contacts = @$refs.contacts_form.contactsToSend()
      @flow.contact_ids_to_be_removed = @$refs.contacts_form.removed_contacts.map (contact) -> contact.id

      flow_attributes = @flow.serialize()
      Loader.on()

      if @flow.isWithError()
        @flow_resource.retry @saveSuccess, @saveFailure, flow_attributes
      else
        @flow_resource.save @saveSuccess, @saveFailure, flow_attributes

    saveSuccess: (resources) ->
      flowCreatedURL = this.$t('flows.label.flowCreatedURL')
      flowContactsLength = this.$t('flows.label.flowContactsLength')
      flowDailyEmailLength = this.$t('flows.label.flowDailyEmailLength')
      flowActiveAfterCreated = this.$t('flows.label.flowActiveAfterCreated')
      flowActiveBBC = this.$t('flows.label.flowActiveBBC')
      flowActionsNumber = this.$t('flows.label.flowActionsNumber')
      Loader.off()
      @$router.push { path: "/fluxos-de-cadencia/" }
      IntercomCtrl.trackEvent(this.$t('flows.label.flowStatus', { status: @type_of_action }),
      {
         flowCreatedURL: location.href,
         flowContactsLength: @flow.contacts.length,
         flowDailyEmailLength: if resources.flow.emails_per_day == null then this.$t('general.label.none') else resources.flow.emails_per_day,
         flowActiveAfterCreated: if resources.flow.status == 'paused' then this.$t('general.label.no') else this.$t('general.label.yes'),
         flowActiveBBC: if resources.flow.bcc then this.$t('general.label.yes') else this.$t('general.label.no'),
         flowActionsNumber: resources.flow.actions.length
      })

    saveFailure: (response) ->
      Loader.off()
      
      unless @handleContactPickerErrors(response.body.errors.details, response.body.errors.messages)
        jQuery('html, body').animate({scrollTop: 0}, 500);
        alertify.error this.$t('flows.feedback.unknownErrorOnCreate')

    isValid: ->
      !@errors.any() and !@anyActionErrors()

    toggleHasEmailsPerDay: ->
      @has_emails_per_day = !@has_emails_per_day
      @flow.emails_per_day = if @has_emails_per_day then 0 else null

    toggleWeekday: (weekday_number) ->
      if @weekdaySelected weekday_number
        @flow.weekdays_to_send = (d for d in @flow.weekdays_to_send when d != weekday_number)
      else
        @flow.weekdays_to_send.push weekday_number

    weekdaySelected: (weekday_number) ->
      weekday_number in @flow.weekdays_to_send

    handleTriggerSandErrors: (data) ->
      for error in data['triggers.action_value']
        @errors.errors.push({ field: 'Ação', msg: error.error })
      jQuery('html, body').animate({scrollTop: 0}, 500);

    handleContactPickerErrors: (data, messages) ->
      if data['triggers.action_value'] 
        @handleTriggerSandErrors(data) 
        return true

      recipients_errors = data['recipients'] || data['recipients.contact.email']
      return @handlerContactListErrors(data, messages) unless recipients_errors
      emails = recipients_errors.map (error) -> error.value
      errors = taken_emails: emails
      EventsBus.$emit 'contacts-picker-text-csv-errors', { errors }
      jQuery('#contacts-manual-picker').modal 'show'

    handlerContactListErrors: (data, messages) ->
      error_messages = messages['contacts']
      contact_errors = data['contacts']
      return false unless contact_errors

      for message, idx in error_messages
        console.log(contact_errors[idx])
        @errors.errors.push({ field: 'Listagem', msg: message })
      jQuery('html, body').animate({scrollTop: 0}, 500);

    handleTemplatesPickerErrors: (data) ->
      if data.errors.any()
        Vue.set @action_errors, 'template', 'A escolha dos templates é obrigatória'

    handleSendAtPickerErrors: (data) ->
      for error in data.errors.errors
        if error.field == 'send_at' and error.rule == 'regex'
          Vue.set @action_errors, 'send_at', this.$t('flows.label.error.invalidFormat')

        else if error.field == 'delay_after_previous_step_amount' and error.rule == 'between'
          Vue.set @action_errors, 'delay_after_previous_step_amount', this.$t('flows.label.error.fieldSendAfterError')

        else
          Vue.set @action_errors, 'required', error.msg

      # This is what I call ugly :( Big refactor flag here
      @validateAndSaveFlow() if @save_flow_after_validations

    anyActionErrors: ->
      ! jQuery.isEmptyObject @action_errors

    ensureActionStepOrder: ->
      current_step = 0
      sorted_actions = Object.values(@flow.actions).sort(@actionSorter)
      for action in sorted_actions
        if !action._destroy
          action.step = current_step
          action.human_step = current_step
          current_step += 1

    ensureActionSendAt: ->
      return if @flow.actions[0].send_at || @flow.actions[0].send_at_kind != 'immediately'
      now = moment()
      @flow.actions[0].send_at = now.add(now.utcOffset(), 'minutes')

    ensureEmailsPerDay: ->
      @flow.emails_per_day = if @has_emails_per_day then @flow.emails_per_day else null

    ensureEmptyTaskParameters: ->
      for action in @flow.actions
        continue unless action.type == 'EmailFlowAction'
        action.manual_task_parameters = {}

    actionSorter: (action_1, action_2) ->
      if action_1.step < action_2.step
        return -1
      if action_1.step > action_2.step
        return 1
      0

    setFlow: (flow) ->
      @flow = flow
      @has_emails_per_day = @flow.emails_per_day > 0
      @old_activation_limit = @flow.emails_per_day if @flow.id
      EventsBus.$emit 'flow-set', flow: @flow
  
  watch:
    flow: (new_flow) ->
      @setFlow(new_flow)
      @errors.clear()

  created: ->
    this.sent_to_flow = false

    @flow_resource = new FlowsResource Session.current_company.id

    @delay_before_finishing_contact_options = [
      { value: 'days', text: helpers.masks.capitalizeFirstLetter(this.$t('general.label.days')) }
      { value: 'weeks', text: helpers.masks.capitalizeFirstLetter(this.$t('general.label.weeks')) }
      { value: 'months', text: helpers.masks.capitalizeFirstLetter(this.$t('general.label.months')) }
    ]

    EventsBus.$on 'validate-all', @validateAll
    EventsBus.$on 'templates-picker-errors', @handleTemplatesPickerErrors
    EventsBus.$on 'flows-send-at-picker-errors', @handleSendAtPickerErrors

  beforeDestroy: ->
    EventsBus.$off 'validate-all', @validateAll
    EventsBus.$off 'templates-picker-errors', @handleTemplatesPickerErrors
    EventsBus.$off 'flows-send-at-picker-errors', @handleSendAtPickerErrors

  mounted: ->
    @loadFlowCategories()
    @$nextTick =>
      @errors.clear()
}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/flows/form.vue